import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia";
import { Dialog } from "@certn/cascadia-react";
import { components } from "@certn/api/generated-schemas/client-portal";
import { useTranslation } from "react-i18next";
import { CommonFields } from "./learn-more-modal/CommonFields";

export type AddOnLearnMoreData = components["schemas"]["CheckAddOnLearnMore"];

interface AddOnLearnMoreModalProps {
  show: boolean;
  onClose: () => void;
  data: AddOnLearnMoreData;
}

export function AddOnLearnMoreModal({
  show,
  onClose,
  data,
}: AddOnLearnMoreModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={show} testID="add-on-learn-more-modal">
      <Dialog width={560}>
        <DialogHeader onClose={onClose}>{data.name}</DialogHeader>
        <DialogContent>
          <CommonFields
            description={data.description}
            estimatedTurnaroundTime={data.turn_around_time}
            coverage={data.coverage}
            keyFeatures={data.key_features}
            howItCanHelpYou={data.how_it_can_help_you}
            disclaimers={data.disclaimers}
          />
        </DialogContent>
        <DialogFooter>
          <PrimaryButton
            size="medium"
            onPress={onClose}
            aria-label={t("Close button")}
            testID="add-on-learn-more-modal-close-button"
          >
            {t("Close")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
